import script from "./ActionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionCard.vue?vue&type=script&setup=true&lang=js"

import "./ActionCard.vue?vue&type=style&index=0&id=23e2b063&lang=css"

const __exports__ = script;

export default __exports__